var _mask, _mask2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfettiBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 848,
    height: 302,
    fill: "none",
    viewBox: "0 0 848 302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "cfftqt8lga",
    width: 848,
    height: 302,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A5068",
    d: "M0 0H848V302H0z"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "if4xab2t5b",
    width: 848,
    height: 302,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A5068",
    d: "M0 0H848V302H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#if4xab2t5b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M18.881 296.956l6.444-1.111.889 6.443-6.222.889-1.11-6.221z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M139.313 212.965l-1.334 2.666-2.444-1.333 1.111-2.666 2.667 1.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear)",
    d: "M754.133 177.414l-2.666-3.333 3.333-2.666 2.666 3.333-3.333 2.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear)",
    d: "M.661 87.87l2.222-5.556 5.777 2.222-2.444 5.555L.661 87.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear)",
    d: "M161.532 145.64l1.111 1.999-1.999 1.111-1.111-1.999 1.999-1.111z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear)",
    d: "M287.074 42.319l2.444-5.555 5.778 2.444-2.667 5.777-5.555-2.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear)",
    d: "M80.652 173.858l4-1.111.889 4.222-4 .889-.889-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear)",
    d: "M485.274 102.533l.667 5.555-5.555.667-.667-5.555 5.555-.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear)",
    d: "M161.088 80.313l3.777-.89.889 3.778-3.777.889-.889-3.777z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear)",
    d: "M231.08 112.754l-3.111-3.777 3.778-3.111 3.11 3.778-3.777 3.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear)",
    d: "M653.478 159.415l.222-2.222 2.222.445-.222 2.222-2.222-.445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear)",
    d: "M485.052 31.875l-1.333-2 2.222-1.333 1.111 2.222-2 1.111z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_linear)",
    d: "M631.925 46.094l-2-5.777 5.777-2 2 5.777-5.777 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_linear)",
    d: "M572.598 46.763l4.666.666-.667 4.666-4.666-.666.667-4.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_linear)",
    d: "M393.951 150.084l.222 1.555-1.555.445-.222-1.556 1.555-.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint15_linear)",
    d: "M92.207 205.854l-3.11 2.666-2.89-2.888 3.111-2.889 2.889 3.111z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint16_linear)",
    d: "M241.079 188.08l-5.111 1.111-1.111-5.11 5.111-1.111 1.111 5.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint17_linear)",
    d: "M32.658 218.744l2.666-6.444 6.444 2.666-2.667 6.444-6.443-2.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint18_linear)",
    d: "M354.844 72.757l1.111-2.222 2.222.889-1.111 2.222-2.222-.889z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint19_linear)",
    d: "M118.426 58.76l-.667-2.222 2.222-.444.667 2.222-2.222.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint20_linear)",
    d: "M561.043 140.307l1.556-4.888 4.888 1.555-1.555 4.889-4.889-1.556z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint21_linear)",
    d: "M742.357 70.315l-7.11-.444.444-6.889 6.888.223-.222 7.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint22_linear)",
    d: "M301.295 116.31l3.777.888-.889 3.778-3.777-.667.889-3.999z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint23_linear)",
    d: "M719.693 177.191l-5.333.666-.667-5.332 5.333-.889.667 5.555z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint24_linear)",
    d: "M790.796 129.42l2-6.443 6.443 2.222-2.222 6.221-6.221-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint25_linear)",
    d: "M85.985 12.542l2-7.555 7.555 2-2 7.555-7.555-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint26_linear)",
    d: "M684.808 75.646l-1.111-2.889 2.888-1.11 1.111 2.888-2.888 1.111z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint27_linear)",
    d: "M780.797 3.655l.444 5.555-5.555.667-.666-5.777 5.777-.445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint28_linear)",
    d: "M419.504 49.428l.444-2 2 .445-.444 2-2-.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint29_linear)",
    d: "M43.768 16.764l-3.555 2-2-3.555 3.555-2 2 3.555z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint30_linear)",
    d: "M358.844 14.765l-6.444-3.999 3.999-6.444 6.444 3.778-3.999 6.665z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint31_linear)",
    d: "M47.1 270.071v1.778h-1.777v-1.778h1.778z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint32_linear)",
    d: "M840.791 240.741l-7.111-2.444 2.444-7.11 7.111 2.444-2.444 7.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint33_linear)",
    d: "M824.792 31.651l-.222-3.11 3.111-.223.222 2.889-3.111.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint34_linear)",
    d: "M177.752 8.765l5.333-4.888 4.889 5.333-5.333 4.888-4.889-5.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint35_linear)",
    d: "M46.878 94.977l4-1.11 1.111 3.999-3.777 1.11-1.334-3.999z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint36_linear)",
    d: "M228.192 34.541l5.999 2.666-2.666 6.222-6-2.666 2.667-6.222z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint37_linear)",
    d: "M774.575 276.292l1.778.667-.667 1.777-1.777-.666.666-1.778z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint38_linear)",
    d: "M726.154 21.064c0 .64-.213 1.28-.64 2.133-4.052-6.399-25.594-13.224-26.234-24.315v-.64c0-.427.213-1.066.426-1.493 3.2 10.878 26.022 17.49 26.448 24.102v.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint39_linear)",
    d: "M726.154 21.063v4.265c-.426 7.039-23.248 15.784-23.462 23.249V44.31c.214-6.825 18.983-14.504 22.822-21.329.427-.64.64-1.28.64-1.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint40_linear)",
    d: "M766.423 9.808v8.532c0-1.28-.213-2.56-.639-3.626-2.347-8.105-11.305-14.29-14.077-22.182V-16c3.412 9.171 14.29 15.783 14.716 25.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint41_linear)",
    d: "M766.423 19.62c0 .639 0 1.492-.213 2.132-1.066 6.185-6.399 13.437-9.171 18.77-2.986 5.545-5.119 11.304-6.399 17.703-.213 1.28-.427 2.559-.427 3.839C750 60.57 750 59.29 750 57.798c0-2.56.213-5.332.64-8.105 1.066-6.399 3.413-12.158 6.399-17.703 2.559-4.692 7.038-11.304 8.744-17.063.427 1.066.64 2.346.64 3.626v1.066z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint42_linear)",
    d: "M770.263 125.412c0 3.199-.853 6.399-2.346 8.958v-8.531c1.066-1.707 1.706-3.626 1.919-5.546.213 1.28.213 2.559.427 3.839v1.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint43_linear)",
    d: "M770.262 116.025v7.892c0-1.28-.213-2.56-.426-3.84-1.706-11.517-8.958-24.101-13.011-30.5-4.479-6.825-6.825-14.93-6.825-23.249v-8.531c0 1.493 0 2.773.213 4.266.64 6.825 2.986 13.437 6.612 18.982 4.906 7.252 13.437 22.609 13.437 34.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint44_linear)",
    d: "M86.423-3.06c0 .64 0 1.066-.213 1.706-1.066 4.906-6.399 10.665-9.171 14.717-2.987 4.48-5.333 8.958-6.4 14.077-.212 1.067-.426 1.92-.426 2.986C70 29.36 70 28.293 70 27.014c0-2.133.213-4.266.64-6.4 1.066-5.118 3.412-9.597 6.399-14.076 2.56-3.84 7.038-8.958 8.744-13.437.427.853.64 1.92.64 2.772v1.067z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint45_linear)",
    d: "M90.476 80.337c0 2.56-.853 4.906-2.346 7.039V80.55c1.066-1.28 1.706-2.772 1.92-4.479.213 1.067.213 2.133.426 2.986v1.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint46_linear)",
    d: "M90.476 73.085v6.186c0-1.067-.213-1.92-.427-2.987-1.706-9.171-8.958-18.982-13.224-24.101C72.346 46.85 70 40.452 70 33.84v-6.825c0 1.066 0 2.346.213 3.412.64 5.333 2.986 10.451 6.612 14.93 4.906 5.76 13.65 17.703 13.65 27.728z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint47_linear)",
    d: "M145.154 30.85c0 .64-.213 1.28-.64 2.133-4.052-6.399-25.594-13.224-26.234-24.315v-.64c0-.426.213-1.066.426-1.493 3.2 10.878 26.022 17.49 26.448 24.102v.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint48_linear)",
    d: "M145.154 30.85v4.266c-.426 7.039-23.248 15.784-23.462 23.249v-4.266c.214-6.825 18.983-14.504 22.822-21.329.427-.426.64-1.28.64-1.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint49_linear)",
    d: "M148.78-17.139v4.266c0 9.385-26.661 11.518-30.074 19.41-.213.426-.426.853-.426 1.492V3.764c.64-8.319 25.808-10.452 29.86-18.557.427-.853.64-1.706.64-2.346z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint50_linear)",
    d: "M45.637 94.502v1.352c0 .386-.193.773-.193 1.352 0-.773-.194-1.545-.194-2.511-.772-5.023-3.477-8.307-6.954-10.625 1.159-.386 2.318-.966 3.284-1.546 1.932 2.125 3.477 4.637 3.864 8.114.193 1.545.193 2.704.193 3.864z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint51_linear)",
    d: "M45.637 15.492c0 .386-.194.773-.194.966 0-.773-.193-1.739-.58-2.705-1.158-4.056-4.442-6.568-8.306-7.727 1.352-.773 2.705-1.545 3.864-2.318 2.318 1.352 4.056 3.284 4.83 6.182.386 1.159.579 2.318.579 3.477-.193.773-.193 1.545-.193 2.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint52_linear)",
    d: "M47.955 35.774c0 .773 0 1.546-.193 2.318 0 .387-.193.58-.193.966-.194-2.704-1.16-5.409-3.091-7.92-1.353-1.546-2.705-2.705-4.057-3.67.773-.773 1.739-1.546 2.318-2.512.773.58 1.352 1.352 2.125 2.125 2.125 2.705 3.09 5.796 3.09 8.693z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint53_linear)",
    d: "M50.466 66.685v1.159c0 .58-.193.966-.193 1.352 0-1.16-.387-2.318-.773-3.477-1.738-5.989-6.375-8.693-11.398-9.66 1.353-.965 2.512-1.931 3.671-3.09 3.477 1.352 6.568 4.056 7.92 8.693.58 1.932.966 3.477.773 5.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint54_linear)",
    d: "M38.489 80.207c-1.932.58-3.864 1.16-5.602 1.546-5.023-1.546-10.046-1.353-13.137-.387-.58-.193-.965-.386-1.352-.772-.58-.387-.773-.773-.773-1.16-.193-2.897 12.364-4.636 20.864.773z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint55_linear)",
    d: "M38.489 52.193c-3.477 2.319-7.534 3.864-12.17 4.057-3.091.193-4.444-.193-4.444-.773 0-1.738 8.887-4.83 16.614-3.284z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint56_linear)",
    d: "M36.75 2.163c-1.932 1.159-4.25 2.124-6.568 2.897-4.83-.193-9.466.58-12.17 1.932-.966 0-1.546-.386-1.739-.966 0-.193-.193-.386-.193-.58v-.193c.58-3.09 12.17-5.795 20.67-3.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint57_linear)",
    d: "M40.807 23.605c-1.159.965-2.318 1.738-3.67 2.51-4.25-1.158-8.5.194-10.625 1.74-.193 0-.387-.194-.58-.194-.58-.386-.772-.773-.966-1.159 0-2.704 8.307-7.34 15.841-2.897z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint58_linear)",
    d: "M45.637 95.853l-.194 3.09v.387C44.092 114.59 23.229 120 23.229 120l.193-3.864s19.318-5.022 21.83-18.931c.193-.387.193-.966.386-1.352z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint59_linear)",
    d: "M44.284-4.406l-.193 3.284c0 1.545-1.352 3.284-3.67 4.83-1.16.772-2.318 1.545-3.864 2.317-7.92 4.057-19.125 6.762-20.477 3.864-.193-.386 0 .193.193-4.443 0 .193 0 .386.193.58.194.579.773.965 1.739 1.159 2.511.58 7.34-.387 12.17-2.125C32.5 4.287 34.82 3.32 36.75 2.162c2.898-1.546 5.41-3.284 6.569-5.023.579-.58.772-.966.965-1.545z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint60_linear)",
    d: "M45.636 15.49l-.193 2.512v.386c-.193 2.511-1.159 4.636-2.511 6.568-.773.966-1.546 1.739-2.318 2.511-4.83 4.057-11.784 5.796-14.875 4.057-.773-.386-.966-.966-.773-1.545l.193-3.477c0 .386.387.965.966 1.159.193 0 .387.193.58.193 2.511.966 6.761.193 10.625-1.739 1.352-.773 2.511-1.545 3.67-2.511 2.125-1.932 3.864-4.25 4.636-7.148-.193-.193-.193-.58 0-.966z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint61_linear)",
    d: "M47.761 40.218v1.352c-.386 4.057-2.51 8.307-5.795 11.59-1.159 1.16-2.318 2.126-3.67 3.092-3.478 2.318-7.534 3.863-12.17 4.056-2.898.194-4.25-.193-4.444-.58v-.386l.193-3.863c0 .58 1.353.966 4.444.773 4.636-.194 8.693-1.739 12.17-4.057 4.83-3.284 8.113-8.114 9.273-13.136v1.159z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint62_linear)",
    d: "M50.466 67.842l-.193 3.09v.387c-.386 5.216-4.057 8.886-8.693 11.398-1.16.58-2.125.966-3.284 1.545-7.727 2.898-17 2.705-20.09.386-.58-.386-.774-.772-.774-1.159v-.193l.194-3.67c0 .386.386.772.772 1.159.387.193.773.58 1.352.773 2.705.965 7.728 1.159 12.944.193 1.931-.387 3.863-.773 5.602-1.546 5.602-2.125 10.432-5.602 11.784-11.01.193-.387.386-.967.386-1.353z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 25.762,
    x2: 19.501,
    y1: 299.022,
    y2: 300.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 136.751,
    x2: 138.021,
    y1: 214.952,
    y2: 212.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 753.154,
    x2: 755.725,
    y1: 172.72,
    y2: 176.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#FCE960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#F4D753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#E7BA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#D59120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C36903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 5.768,
    x2: 3.531,
    y1: 83.386,
    y2: 88.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#FCE960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#F4D753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#E7BA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#D59120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C36903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 159.506,
    x2: 162.576,
    y1: 146.869,
    y2: 147.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCB637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#CA9E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#9C6114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 292.33,
    x2: 289.839,
    y1: 37.987,
    y2: 43.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCB637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#CA9E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#9C6114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 81.668,
    x2: 84.561,
    y1: 177.795,
    y2: 172.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 479.831,
    x2: 485.845,
    y1: 103.27,
    y2: 107.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 162.034,
    x2: 164.664,
    y1: 84.052,
    y2: 79.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 229.923,
    x2: 232.881,
    y1: 107.425,
    y2: 111.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 654.879,
    x2: 654.523,
    y1: 157.402,
    y2: 159.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 487.075,
    x2: 483.852,
    y1: 30.666,
    y2: 29.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#FCE960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#F4D753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#E7BA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#D59120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C36903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 632.771,
    x2: 634.745,
    y1: 39.25,
    y2: 44.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 576.905,
    x2: 572.33,
    y1: 49.764,
    y2: 49.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#FCE960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#F4D753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#E7BA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#D59120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C36903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 392.466,
    x2: 394.219,
    y1: 150.471,
    y2: 151.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 87.719,
    x2: 90.701,
    y1: 207.106,
    y2: 204.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 239.881,
    x2: 236.217,
    y1: 183.105,
    y2: 189.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#FCE960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#F4D753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#E7BA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#D59120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C36903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 39.18,
    x2: 35.351,
    y1: 221.272,
    y2: 212.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCB637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#CA9E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#9C6114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 357.039,
    x2: 356.026,
    y1: 71.012,
    y2: 73.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 118.904,
    x2: 119.506,
    y1: 56.305,
    y2: 58.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 566.03,
    x2: 562.767,
    y1: 141.837,
    y2: 135.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#FCE960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#F4D753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#E7BA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#D59120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C36903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 742.527,
    x2: 735.589,
    y1: 63.314,
    y2: 69.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 304.649,
    x2: 300.823,
    y1: 119.135,
    y2: 118.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#FCE960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#F4D753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#E7BA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#D59120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C36903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 718.888,
    x2: 714.49,
    y1: 171.74,
    y2: 177.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 796.023,
    x2: 793.852,
    y1: 124.147,
    y2: 130.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCB637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#CA9E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#9C6114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 91.655,
    x2: 89.677,
    y1: 6.066,
    y2: 13.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 687.556,
    x2: 683.818,
    y1: 74.415,
    y2: 72.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 778.494,
    x2: 777.952,
    y1: 9.55,
    y2: 3.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCB637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#CA9E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#9C6114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 421.033,
    x2: 420.57,
    y1: 47.611,
    y2: 49.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 39.204,
    x2: 42.66,
    y1: 16.939,
    y2: 14.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 362.69,
    x2: 352.735,
    y1: 8.144,
    y2: 10.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#FCE960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#F4D753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#E7BA3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#D59120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C36903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 45.301,
    x2: 47.087,
    y1: 270.125,
    y2: 271.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 834.931,
    x2: 841.971,
    y1: 234.829,
    y2: 237.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCB637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#CA9E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#9C6114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 826.089,
    x2: 826.41,
    y1: 28.402,
    y2: 31.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 182.743,
    x2: 183.084,
    y1: 14.07,
    y2: 4.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCB637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#CA9E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#9C6114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 51.497,
    x2: 47.561,
    y1: 95.785,
    y2: 96.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 232.913,
    x2: 226.841,
    y1: 40.318,
    y2: 37.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 773.898,
    x2: 776.292,
    y1: 278.044,
    y2: 276.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 688.417,
    x2: 753.366,
    y1: 4.776,
    y2: 18.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 702.811,
    x2: 726.218,
    y1: 34.747,
    y2: 34.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 741.42,
    x2: 792.99,
    y1: -3.61,
    y2: 10.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 750.064,
    x2: 766.5,
    y1: 38.406,
    y2: 38.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 736.354,
    x2: 780.856,
    y1: 129.34,
    y2: 126.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 731.793,
    x2: 811.177,
    y1: 81.131,
    y2: 108.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 69.965,
    x2: 86.515,
    y1: 11.855,
    y2: 11.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 57.877,
    x2: 100.38,
    y1: 83.742,
    y2: 81.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 54.88,
    x2: 125.559,
    y1: 44.46,
    y2: 68.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 107.337,
    x2: 172.285,
    y1: 14.71,
    y2: 28.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 121.73,
    x2: 145.138,
    y1: 44.683,
    y2: 44.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 118.276,
    x2: 148.774,
    y1: -4.676,
    y2: -4.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 17.003,
    x2: 62.42,
    y1: 86.727,
    y2: 92.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 15.435,
    x2: 64.42,
    y1: 8.88,
    y2: 11.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 26.532,
    x2: 60.487,
    y1: 29.555,
    y2: 34.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 23.122,
    x2: 66.159,
    y1: 59.466,
    y2: 62.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 18.018,
    x2: 63.434,
    y1: 78.375,
    y2: 83.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 23.549,
    x2: 66.586,
    y1: 53.606,
    y2: 56.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 15.676,
    x2: 64.661,
    y1: 3.686,
    y2: 5.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 27.233,
    x2: 61.187,
    y1: 24.436,
    y2: 29.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 23.183,
    x2: 45.582,
    y1: 107.967,
    y2: 107.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 15.887,
    x2: 44.246,
    y1: 3.374,
    y2: 3.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 24.789,
    x2: 45.571,
    y1: 23.934,
    y2: 23.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: 21.571,
    x2: 47.714,
    y1: 49.672,
    y2: 49.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: 17.192,
    x2: 50.479,
    y1: 77.028,
    y2: 77.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#F9CF3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ECB732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#CB7A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB5D00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfettiBackground);
export default __webpack_public_path__ + "static/media/confetti_background.8e494af6b2523a702448f556d7b19a9a.svg";
export { ForwardRef as ReactComponent };